import type { App } from 'vue';
import type { RouteRecordRaw, Router } from 'vue-router';

export type ModuleId = 'sms' | 'tariffs' | 'cdp' | 'tracker';

export interface MenuItem {
  title: string;
  /** Vue-router target. Either a full path or a route name. */
  to: string | { name: string };
  /** DevExtreme icon name. */
  icon?: string;
  /** Hide from the side nav even though the route exists. */
  hidden?: boolean;
  /**
   * Show only when the JWT for this section's module audience includes the
   * permission (or ``admin:all``). Example: ``admin:all``.
   */
  requiresPermission?: string;
}

export interface MenuSection {
  id: ModuleId;
  title: string;
  icon?: string;
  items: MenuItem[];
}

export interface ModuleManifest {
  id: ModuleId;
  title: string;
  /** Routes scoped to /{id}/* (modules already include the prefix). */
  routes: RouteRecordRaw[];
  /** Top-level menu section for the side nav. */
  menu: MenuSection;
  /** Optional install hook called after the app is created. */
  init?: (ctx: { app: App; router: Router }) => void | Promise<void>;
}

/** Register a module against the host shell. */
export async function registerModule(
  ctx: { app: App; router: Router },
  manifest: ModuleManifest,
): Promise<void> {
  for (const route of manifest.routes) {
    ctx.router.addRoute(route);
  }
  if (manifest.init) await manifest.init(ctx);
}
